/**
 * Regras de TELA do checklist de execução da O.S. — o que mostrar, não o que vale.
 * O servidor valida tudo de novo (`work-order-checklist-rules.ts` na API).
 */
import type { MaintenanceWorkOrderChecklistItemDto, MaintenanceWorkOrderChecklistStatusDto } from "@bi/types";

export const CHECK_LABEL: Record<MaintenanceWorkOrderChecklistStatusDto, string> = {
  pending: "Pendente",
  done: "Realizado",
  not_done: "Não realizado",
  not_applicable: "Não se aplica",
};

export const NOT_DONE_REASONS = [
  { value: "parts_unavailable", label: "Peça indisponível" },
  { value: "outsourced", label: "Serviço terceirizado" },
  { value: "not_needed", label: "Não havia necessidade" },
  { value: "problem_found", label: "Problema identificado" },
  { value: "other", label: "Outro" },
] as const;

export const reasonText = (v: string | null) => NOT_DONE_REASONS.find((r) => r.value === v)?.label ?? v ?? "";

export type ChecklistFilter = "all" | "pending" | "done" | "problems";

export const FILTERS: Array<{ id: ChecklistFilter; label: string }> = [
  { id: "all", label: "Todos" },
  { id: "pending", label: "Pendentes" },
  { id: "done", label: "Realizados" },
  { id: "problems", label: "Problemas" },
];

export function matchesFilter(i: Pick<MaintenanceWorkOrderChecklistItemDto, "status">, f: ChecklistFilter): boolean {
  if (f === "pending") return i.status === "pending";
  if (f === "done") return i.status === "done";
  if (f === "problems") return i.status === "not_done";
  return true;
}

export interface ChecklistSection {
  name: string;
  items: MaintenanceWorkOrderChecklistItemDto[];
  done: number;
  total: number;
}

/** Agrupa por seção na ordem em que aparecem (a ordem do modelo no snapshot). */
export function groupBySection(items: MaintenanceWorkOrderChecklistItemDto[]): ChecklistSection[] {
  const out: ChecklistSection[] = [];
  for (const i of [...items].sort((a, b) => a.order - b.order)) {
    let s = out.find((x) => x.name === i.sectionName);
    if (!s) { s = { name: i.sectionName, items: [], done: 0, total: 0 }; out.push(s); }
    s.items.push(i);
    s.total++;
    if (i.status === "done") s.done++;
  }
  return out;
}
